export default __webpack_public_path__ + "static/media/2012-IMcover.d9697507.jpg";